var underscoreString = require('underscore.string');
var Dinero = require('dinero.js');

module.exports = {
    capitalize: underscoreString.capitalize,
    isBlank: underscoreString.isBlank,
    trim: underscoreString.trim,
    currency: function (value) {
      // dinero deals in cents hence the * 100, also using the USD formatting.
      if (value) {
        return Dinero({ amount: Math.round(parseFloat(value) * 100), currency: 'USD' }).toFormat()
      } else {
        return '$0.00';
      }
    },
    num_cond: function ($var1, $op, $var2) {
      switch ($op) {
          case "=":  return $var1 == $var2;
          case "!=": return $var1 != $var2;
          case ">=": return $var1 >= $var2;
          case "<=": return $var1 <= $var2;
          case ">":  return $var1 >  $var2;
          case "<":  return $var1 <  $var2;
          default:       return true;
      }
    },
    matchWildCard: function (str, rule) {
      var escapeRegex = (str) => str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
      return new RegExp("^" + rule.split("*").map(escapeRegex).join(".*") + "$").test(str);
    },
    decimalToPercentage: function (decimal) {
      return Math.round(decimal * 100) + '%';
    },
    stripSlashes: function (str) {
      return (str + '').replace(/\\(.?)/g, function (s, n1) {
        switch (n1) {
        case '\\':
          return '\\';
        case '0':
          return '\u0000';
        case '':
          return '';
        default:
          return n1;
        }
      });
    }
};



/** WEBPACK FOOTER **
 ** ./assets/js/utils/strings.js
 **/